import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form'

import userActions from '../../context/users/actions';
import { ToastContainer, notify } from '../../libraries/notifications';
import { composeValidators, validateIsfilled, validateOnlyNumber, capitalize, uuidv4, formatOnlyNumberInput, months } from '../../libraries/utils';

import { history } from '../../routes';
import config from '../../config';

import LayoutSmall from '../../components/layout/LayoutSmall';
import Button from '../../components/commons/Button';
import TextInput from '../../components/forms/TextInput';
import SelectInput from '../../components/forms/SelectInput';
import internalsActions from '../../context/internals/actions';
import Swal from 'sweetalert2';

class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      submitting: false,
      signupData: {},
    }
  }
  
  componentDidMount() {
    this.generate_captcha()
  }
 
  onSubmit = async (values) => {
    if(parseInt(values.result) != this.state.captcha?.result){
      alert("resultado incorrecto")
      this.generate_captcha()
      return
    }
    this.setState({submitting: true});
    await this.props.onVerifyID({ identification: values.identification, user_type: 'patient' });
    const { error, verify } = this.props.internals;
    if(error){
      notify(this.t(error.message))
    }
    else{
      if(verify.exists){
        Swal.fire({
          title: "El documento se encuentra registrado",
          text: `${values.identification.substring(0,2) + '*'.repeat(6)}`,
          icon: 'warning',
        })
      }
      else{
        history.push({pathname: config.ROUTES.SIGNUP_VERIFICATION2, state: {identification:values.identification, identification_type:values.identification_type}});
      }
    }
    
//    await this.props.onGetQuestions({identification: values.identification})
//    console.log(this.props.internals.error)//this.props.internals.resultado["Novedad"]
//    const internals_error = this.props.internals.error;
//    if (internals_error) {
//      notify(this.t(internals_error.message + " " ));
//      this.setState({"error": internals_error.message})
//    } else {
//      console.log("this.props.internals", this.props.internals)
//      const {Desafios, IdConsulta, Novedad, Estado} = this.props.internals.questions
//
//      if(Estado !== 200){
//        this.setState({"error": `Error: ${Novedad}`})
//        //this.setState({ user });
//        return
//      }
//      
//      this.setState({desafios: Desafios, id_consulta: IdConsulta})
//      return
//      //history.push({pathname: config.ROUTES.SIGNUP_VERIFICATION2, state: {identification:values.identification}});
//    
//    }
  }

  gotoBack = async () => {
    history.push(config.ROUTES.USER.INFO);
  }

  onTerms = () => {
    history.push(config.ROUTES.TERMS);
  }

  onLogin = () => {
    history.push(config.ROUTES.LOGIN);
  }

  generate_captcha = () => {
    let n1 = parseInt(Math.random()*5) + 1
    let n2 = parseInt(Math.random()*5) + 1
    if(n1 < n2){
      [n1, n2] = [n2, n1];
    }
    let sign = parseInt(Math.random()*3)
    let signs = ["*","+","-"]
    let operation = `${n1}${signs[sign]}${n2}`
    let result = eval(`${n1}${signs[sign]}${n2}`)

    this.setState({captcha:{
      operation,
      result
    }})
  } 

  render() {
    const { signupData, captcha } = this.state;
    
    const required = value => (validateIsfilled(value) ? undefined : this.t("This field is required"))
    //const required_date = value => (isDate(value) ? undefined : this.t("This field is required"))
    //const email = value => (validateEmail(value) ? undefined : this.t("Not a valid email"))
    const onlynumber = value => (validateOnlyNumber(value) ? undefined : this.t("El documento solo debe llevar digitos"))
    const dnilength = value => (value.length >= 7 && value.length <= 8 ? undefined : this.t("EL documento debe tener 7 u 8 numeros"))

    const dni_types = config.OPTIONS.SINGUP.IDENTIFICATION.TYPES.map((o) => { return { value: o, label: this.t(o) }});
    const gender_types = config.OPTIONS.SINGUP.GENDER.TYPES.map((o) => { return { value: o, label: capitalize(o) }});
    
    const today = new Date()
    let years = [...Array(today.getFullYear()+1).keys()].slice(1915,today.getFullYear()+1).map(x => {return {label:x, value:x}})
    years.reverse()
    const months_arr = [...Array(13).keys()].slice(1,13).map(x => {return {label:capitalize(months(x-1).slice(0,3)), value:x}})
    const days = [...Array(32).keys()].slice(1,32).map(x => {return {label:x, value:x}})

    return (
      <LayoutSmall
        main={{ className: "bg-base-200 text-primary bg-pattern"}}
        header={{ 
          title: this.t("Register"),
          className: "!bg-transparent !text-primary",
          left: { icon: 'arrow_left', action: () => this.gotoBack() },
        }}
        container= {{
          className: "mt-10",
        }}
      >
        <ToastContainer/>

        <Form
          initialValues={signupData || {}}
          onSubmit={this.onSubmit}
        >
          {({ handleSubmit, submitting, pristine, values,}) => (
            <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto px-4">
              <div className="flex justify-center">{this.t("Informacion Personal")}</div>
     
              <div className="flex mt-5">
                <div className="w-1/3 mr-3">
                  <Field name="identification_type" component={SelectInput} placeholder={this.t("Tipo")} label={this.t("Tipo de Doc.")} validate={required}
                    options={dni_types} 
                    empty={this.t("Seleccione")}
                  />
                </div>
                <div className="w-2/3">
                  <Field name="identification" parse={v => formatOnlyNumberInput(v,8)} component={TextInput} placeholder={this.t("Nro de Documento")} label={this.t("Nro de Documento")} validate={composeValidators(required,onlynumber,dnilength)}/>
                </div>
              </div>

              <div className='flex flex-col items-center'>
              {captcha?.operation && <><label className='label label-text mt-10'>¿Cuál es el resultado de la siguiente operación?:</label> <p className="text-xl">{captcha?.operation}</p></>}
                <div className="w-2/3 mt-4">
                  <Field name="result" parse={v => formatOnlyNumberInput(v,8)} component={TextInput} placeholder={this.t("Resultado")} validate={composeValidators(required,onlynumber)}/>
                </div>
              </div>
              <div className="w-full mt-5">
                <Button
                  className="btn-primary btn-block"
                  title={this.t("Next")}
                  onClick={handleSubmit}
                  disabled={submitting}
                />
              </div>

            </form>
        )}
        </Form>
      </LayoutSmall>
    ) 
  }
}

const mapStateToProps = state => {
  return {
    user: state.users.current,
    internals: state.internals,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onRegister: (params) => dispatch(userActions.saveOrUpdate(params, 'register')),
    onGetQuestions: (params) => dispatch(internalsActions.postQuestions(params)),
    onVerifyID: (params) => dispatch(internalsActions.verifyID(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Signup));
